module.exports = __webpack_public_path__ + "img/h5-truck-poster-bg.eaa05ae9.png";